import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { requireMember } from '@/lib/auth-guards'
import { MyPaymentsPage } from '@/features/my-account/my-payments-page'

const myPaymentsSearchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
})

export const Route = createFileRoute('/_authenticated/my-payments')({
  beforeLoad: requireMember,
  component: MyPaymentsPage,
  validateSearch: myPaymentsSearchSchema,
})
